import { ToolkitListingID, isUndefined } from '@aloft/toolkit-shared';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { useToolkitContext } from '../../../hooks/api/toolkitContext.ts';
import { useToolkitControllerGlobal } from '../useToolkitControllerGlobal.ts';
import { ListingResult } from './types.ts';

export const useGetListing = (
  listingID: ToolkitListingID | undefined,
  disabled = false,
): UseQueryResult<ListingResult> => {
  const { fetcherOptions } = useToolkitContext();
  const { mlsListingsBatcher } = useToolkitControllerGlobal();

  return useQuery(
    ['AbodeListing', listingID ?? 'missing_listing'],
    async () =>
      isUndefined(listingID)
        ? { status: 'missing' }
        : mlsListingsBatcher.fetch(listingID, fetcherOptions),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: !disabled,
    },
  );
};
